import React from "react";

import {
    Spacer2026Block as Value,
    Spacer2026BlockThemed as ValueThemed,
} from "@reactivated";

import {
    concatClassNames,
    getStyleVariantClass,
} from "@thelabnyc/thelabui/src/utils/styles";

import { Themed } from "../../styles/themes";

import styles from "./SpacerBlock.module.scss";

const colorVariants = {
    "accent": styles.colorAccent,
    "contrast": styles.colorContrast,
    "gray-300": styles.colorGray300,
};

const styleVariants = {
    none: "",
    vertical: styles.styleVertical,
    horizontal: styles.styleHorizontal,
};

export const SpacerBlock = ({ value }: { value: Value }) => {
    const className = concatClassNames([
        styles.root,
        getStyleVariantClass(colorVariants, value.line_color),
        getStyleVariantClass(styleVariants, value.line_style),
    ]);

    return value.anchor ? (
        <a
            id={value.anchor}
            className={className}
            style={{ height: `var(${value.height})` }}
        />
    ) : (
        <div
            aria-hidden="true"
            className={className}
            style={{ height: `var(${value.height})` }}
        />
    );
};

export const SpacerBlockThemed = ({
    value: { theme, ...props },
}: {
    value: ValueThemed;
}) => (
    <Themed theme={theme}>
        <SpacerBlock value={props} />
    </Themed>
);
